import dayjs          from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);

export function useIsMandateExpireInLessThan3Months(expiryDate) {

  const expiresInOneWeek = dayjs(expiryDate).isSameOrBefore(dayjs().add(3, 'months'));
  return expiresInOneWeek ? dayjs(expiryDate).format('DD/MM/YYYY') : false;
}